import type { ImageLibraryItem } from '../api/imageLibraryApi';
import { DEFAULT_IMAGE_LIBRARY_PAGE, DEFAULT_IMAGE_LIBRARY_PAGE_SIZE } from '../api/imageLibraryApi';
import type { BrowseSubTab } from './imageInsertTypes';
import type { AllowedPageSize } from './table/ListPagination';

export interface LibraryPanelState {
  searchQuery: string;
  committedQuery: string;
  page: number;
  pageSize: AllowedPageSize;
  totalCount: number;
  hasRequested: boolean;
  isInitialLoad: boolean;
  accountName: string | null;
  accountId: number | null;
  images: ImageLibraryItem[];
  selectedImage: ImageLibraryItem | null;
  isLoading: boolean;
  isLoadingMore: boolean;
  appendError: string | null;
  recoveryAttempted: boolean;
  error: string | null;
  browseSubTab: BrowseSubTab;
  isUploading: boolean;
  uploadError: string | null;
}

export function createInitialLibraryState(
  accountId: number | null = null,
  accountName: string | null = null
): LibraryPanelState {
  return {
    searchQuery: '',
    committedQuery: '',
    page: DEFAULT_IMAGE_LIBRARY_PAGE,
    pageSize: DEFAULT_IMAGE_LIBRARY_PAGE_SIZE,
    totalCount: 0,
    hasRequested: false,
    isInitialLoad: false,
    accountName,
    accountId,
    images: [],
    selectedImage: null,
    isLoading: false,
    isLoadingMore: false,
    appendError: null,
    recoveryAttempted: false,
    error: null,
    browseSubTab: 'emtrain',
    isUploading: false,
    uploadError: null,
  };
}
